exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\r\n  background: #c00000;\r\n  background: linear-gradient(to right, #c00000 82%, #ffffff 83%);\r\n\r\n}\r\n\r\n.container li {\r\n  color: white!important;\r\n}\r\n\r\n.logo {\r\n  min-height: 100%;\r\n  position: relative;\r\n  text-align: right;\r\n}\r\n\r\n.menu-desctop-header {\r\n  color: white;\r\n}\r\n\r\n.menu-desctop-logo { \r\n  padding: 0;\r\n  min-width: 265px;\r\n}\r\n\r\n.menu-desctop-logo img {\r\n  min-height: 70px;\r\n}\r\n\r\n.ti-search {\r\n  max-height:30px;\r\n}\r\n\r\n.mobile-menu-button-top {\r\n  display:none;\r\n}\r\n\r\n.mobile-menu-top {\r\n  display: none;\r\n}\r\n.searchImg{\r\n  width: 40px; \r\n  position: absolute; \r\n  width: 33px;\r\n  right: 13px;\r\n  height: 30px;\r\n  top: 1px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main